import styles from "./BookingFailedPanel.module.scss";

import { useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";

import {
  CreateSessionErrorReasons,
  useBookingContext,
} from "../../context/BookingContext";

interface BookingFailedPanelProps {
  compact?: boolean;
}

export const BookingFailedPanel = ({
  compact = false,
}: BookingFailedPanelProps) => {
  const { t } = useTranslation();

  const { cleanBookingState, createSessionErrorReason, returnToTimeSelection } =
    useBookingContext();

  const isNoCoachAvailable =
    createSessionErrorReason === CreateSessionErrorReasons.NO_COACH_AVAILABLE;
  const isSessionAlreadyStarted =
    createSessionErrorReason ===
    CreateSessionErrorReasons.SESSION_ALREADY_STARTED;

  const copy = isNoCoachAvailable
    ? ({
        titleKey: "coachingSession.bookingFailed.noCoachAvailable.title",
        ctaKey: "coachingSession.bookingFailed.noCoachAvailable.cta",
        onCtaClick: returnToTimeSelection,
      } as const)
    : ({
        titleKey: isSessionAlreadyStarted
          ? "coachingSession.bookingFailed.sessionAlreadyStarted.title"
          : "coachingSession.bookingFailed.title",
        ctaKey: "coachingSession.bookingFailed.cta",
        onCtaClick: cleanBookingState,
      } as const);

  return (
    <div
      className={`${styles.confirmationContainer} ${compact ? styles.compact : ""}`}
    >
      <div className={styles.header}>
        <h1 className={styles.title}>{t(copy.titleKey)}</h1>
        {isNoCoachAvailable && (
          <p className={styles.description}>
            {t("coachingSession.bookingFailed.noCoachAvailable.description")}
          </p>
        )}
      </div>

      <div className={styles.buttonWrapper}>
        <AppButton onClick={copy.onCtaClick} variant="primary">
          {t(copy.ctaKey)}
        </AppButton>
      </div>
    </div>
  );
};
